/**
 * FinSuite AG Grid theme factory (v35 Theming API).
 *
 * Replaces the legacy CSS-class theming ('ag-theme-alpine' / 'ag-theme-alpine-dark')
 * with JS Theme objects passed via the `theme` prop on <AgGridReact>.
 *
 * Theme params are tuned to match FinSuite's existing alpine look (compact rows/headers).
 *
 * TODO(post-SharedUI consolidation): replace with getSharedUIAgGridTheme() from
 * @amzn/das-finsuite-shared-ui/ag-grid once Task 02/05 of the AG Grid consolidation lands.
 */
import { colorSchemeDarkBlue, colorSchemeLight, themeAlpine, type Theme } from 'ag-grid-community';

export type FinSuiteAgGridThemeMode = 'light' | 'dark';

const BASE_THEME = themeAlpine;

// Matches the compact sizing previously set in ag-grid-override.scss + module styles.
const FINSUITE_THEME_PARAMS = {
  fontSize: 12,
  headerFontSize: 10,
  headerVerticalPaddingScale: 0.8,
  cellHorizontalPadding: 10
};

export const getFinSuiteAgGridTheme = (mode: FinSuiteAgGridThemeMode): Theme =>
  BASE_THEME.withPart(mode === 'dark' ? colorSchemeDarkBlue : colorSchemeLight).withParams(FINSUITE_THEME_PARAMS);
